<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
import ContractItem from './ContractItem.vue'
import { page, getById } from '@/api/business/contract'
export default {
  components: {
    MSelectPulldown,
    ContractItem
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: true,
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    async onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      let newCheckedItem = { ...checkedItem }
      if (checkedItem.id) {
        try {
          const res = await this.fetchObject(checkedItem.id)
          if (res.data) {
            newCheckedItem = { ...newCheckedItem, ...res.data }
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.$emit('change', newCheckedItem)
    },
    loadData(keyword) {
      return new Promise((resolve, reject) => {
        const params = {
          ...this.queryParams,
          contractTitle: keyword,
          page: this.page.page,
          size: this.page.size,
          voidStatus: this.$enums.CANCELLATION_STATUS.NOT_CANCELLED.value
        }
        params.sort = ['id,desc']
        page(params).then(res => {
          resolve({
            data: res.data.records
          })
          this.page.total = res.data.total
        }).catch(err => {
          reject(err)
        })
      })
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    async fetchObject(value) {
      return await getById(value)
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :fetch-object="fetchObject"
    :page="page"
    :field="{ value: 'id', label: 'contractTitle' }"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    width="600px"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <contract-item
        v-for="(item, index) in list"
        :key="index"
        :contract="item"
        :active="item.id === localValue"
        @click="$refs.pulldown.onItemChecked(item)"
      />
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
// 样式已移至 ContractItem 组件
</style>
